import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core'
import { ProductListComponentService, ViewConfig } from '@spartacus/storefront'
import { PaginationModel } from '@spartacus/core/src/model/misc.model'
import { ProductSearchPage } from '@spartacus/core'
import { Subscription } from 'rxjs'
import { defaultSearchPageSize } from '../../../config/custom-view-config'

class ViewModes {
}

@Component({
  selector: 'mb-search-results-scroll',
  templateUrl: './mb-search-results-scroll.component.html',
  styleUrls: ['./mb-search-results-scroll.component.scss']
})
export class MbSearchResultsScrollComponent implements OnChanges, OnDestroy {

  private subscription = new Subscription()

  @Input('scrollConfig')
  set setConfig (inputConfig: ViewConfig) {
    this.setComponentConfigurations(inputConfig)
  }

  model: ProductSearchPage | undefined
  @Input('model')
  set setModel (inputModel: ProductSearchPage) {
    this.infiniteScrollOperations(inputModel)
  }

  inputViewMode: ViewModes | undefined
  @Input('inputViewMode')
  set setViewMode (inputViewMode: ViewModes) {
    this.inputViewMode = inputViewMode
    //If viewMode is already set (meaning it is not the first load)
    //Reset the product list
    if (this.viewMode) {
      this.resetListOnViewModeChange()
    } else {
      //If viewMode is not set (meaning it is the first load)
      //Set the viewMode
      this.viewMode = inputViewMode
    }
  }

  viewMode: ViewModes | undefined
  productLimit: number | undefined
  maxProducts: number | undefined

  appendProducts = false
  resetList = false
  isMaxProducts = false
  isLastPage = false
  isEmpty = false

  areResultsCollapsed = true
  numberOfResultsLeft: number | undefined
  searchPageSize = defaultSearchPageSize

  constructor (private productListComponentService: ProductListComponentService,
               private ref: ChangeDetectorRef) { }

  scrollPage (pageNumber: number): void {
    this.appendProducts = true
    this.ref.markForCheck()
    this.productListComponentService.getPageItems(pageNumber)
  }

  loadNextPage (pageNumber: number): void {
    this.isMaxProducts = false
    this.scrollPage(pageNumber)
  }

  scrollToTop (): void {
    window.scroll(0, 0)
  }

  setComponentConfigurations (scrollConfig: ViewConfig): void {
    this.productLimit =  scrollConfig.view?.infiniteScroll?.productLimit
    this.maxProducts = this.productLimit
  }

  infiniteScrollOperations (inputModel: ProductSearchPage): void {
    if (this.appendProducts) {
      this.model = {
        ...inputModel,
        products: this.model?.products?.concat(inputModel.products ?? []),
      }
    } else {
      this.model = inputModel
      this.maxProducts = this.productLimit
    }
    this.numberOfResultsLeft = this.computeNumberOfResultsLeftToRender(this.model?.pagination)
    this.setConditions()
    this.ref.markForCheck()
  }

  resetListOnViewModeChange (): void {
    this.scrollToTop()
    this.resetList = true
    this.productListComponentService.getPageItems(0)
  }

  //Set booleans after model has been retrieved
  setConditions (): void {
    this.isEmpty = !this.model?.products || this.model.products.length === 0

    this.isLastPage =
      this.model?.pagination?.currentPage ===
      (this.model?.pagination?.totalPages ?? 0) - 1

    if (this.model?.products) {
      this.isMaxProducts =
        this.productLimit !== undefined &&
        this.productLimit !== 0 &&
        this.model.products.length >= (this.maxProducts ?? 0)
    }

    //Only change viewMode once the new model is set
    //This prevents flickering issues
    if (this.viewMode !== this.inputViewMode) {
      this.viewMode = this.inputViewMode
    }

    this.resetList = false
    this.appendProducts = false
  }

  handleExpandCollapseClick () {
    this.areResultsCollapsed = !this.areResultsCollapsed
  }

  computeNumberOfResultsLeftToRender (pagination?: PaginationModel) {
    return (pagination?.totalResults !== undefined && pagination?.currentPage !== undefined && pagination?.pageSize !== undefined) ?
      +pagination?.totalResults - ((+pagination?.currentPage + 1) * +pagination?.pageSize) : 0
  }

  ngOnChanges (changes: SimpleChanges) {
    this.areResultsCollapsed = true
    this.numberOfResultsLeft = this.computeNumberOfResultsLeftToRender(this.model?.pagination)
  }

  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }
}
